import React, { useState } from 'react'
import {
  FormGroup,
  FormControl,
  InputLabel,
  Input,
  Button,
  styled,
  Typography,
} from '@mui/material'
import { addRent } from '../Service/api'
import { useNavigate } from 'react-router-dom'


const initialValue = {
  year: '',
  startingRent: '',
  effectiveRent: '',
}

const AddRentPage = () => {
  const [rent, setRent] = useState(initialValue)
  const { year, startingRent, effectiveRent } = rent
  let navigate = useNavigate()

  const onValueChange = (e) => {
    setRent({ ...rent, [e.target.name]: e.target.value })
  }

  const addRentDetails = async () => {
    await addRent(rent)
    navigate('/all')
  }

  return (
    <Container>
      <Typography variant='h4'>Add Rent</Typography>
      <FormControl>
        <InputLabel htmlFor='my-input'>Year</InputLabel>
        <Input
          onChange={(e) => onValueChange(e)}
          name='year'
          value={year}
          id='my-input'
        />
      </FormControl>
      <FormControl>
        <InputLabel htmlFor='my-input'>Starting Rent</InputLabel>
        <Input
          onChange={(e) => onValueChange(e)}
          name='startingRent'
          value={startingRent}
          id='my-input'
        />
      </FormControl>
      <FormControl>
        <InputLabel htmlFor='my-input'>Effective Rent</InputLabel>
        <Input
          onChange={(e) => onValueChange(e)}
          name='effectiveRent'
          value={effectiveRent}
          id='my-input'
        />
      </FormControl>
      <FormControl>
        <Button
          variant='contained'
          color='primary'
          onClick={() => addRentDetails()}
        >
          Add Rent
        </Button>
      </FormControl>
    </Container>
  )
}

const Container = styled(FormGroup)`
  width: 50%;
  margin: 5% 0 0 25%;
  & > div {
    margin-top: 20px;
  }
`
export default AddRentPage


